var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{staticClass:"kt-form"},[(_vm.has_error)?_c('kt-show-msg',{attrs:{"type":"danger"}},_vm._l((_vm._errors),function(error){return _c('span',{key:error},[_vm._v(_vm._s(error))])}),0):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }